import React, { useEffect, useState } from "react";
import Header from "./HostelHeader";
import Nav from "../master/NavBar";
import Footer from "../main/footer";
import { closeModal, SweetAlertShow, LoadingDiv } from "../master/Master";
import {
  HostelAddBed,
  HostelBedDelete,
  HostelBedsList,
  HostelBedStatusChange,
  HostelBedUpdate,
  HostelRoomAdd,
  HostelRoomList,
} from "../../api/HostelService";
import Swal from "sweetalert2";
import WelcomeBar from "./WelcomeBar";
import usePrivateLink from "../config/usePrivateLink";

export default function Rooms() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [beds, setBeds] = useState("");
  const [rooms, setRooms] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [roomId, setRoomID] = useState("");
  const [modalData, setModalData] = useState("");

  const [hostel_id, setHostelId] = useState(localStorage.getItem("hostel_id"));
  useEffect(() => {
    const handleStorageChange = () => {
      setHostelId(localStorage.getItem("hostel_id"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const getHostelRoomsList = async () => {
    setLoading(true);
    let addUrl = "";
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    try {
      const response = await HostelRoomList(addUrl);
      if (response.data?.status) {
        setRooms(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getHostelBedsList = async () => {
    setLoading(true);
    let addUrl = `&page=${page}`;
    if (search) addUrl += `&search=${search}`;
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    if (roomId) addUrl += `&room_id=${roomId}`;
    try {
      const response = await HostelBedsList(addUrl);
      if (response.data?.status) {
        setBeds(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHostelRoomsList();
    getHostelBedsList();
  }, []);

  useEffect(() => {
    getHostelBedsList();
  }, [hostel_id, roomId, search]);

  const createHostelBed = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      formData.append("hostel_id", hostel_id);
      const response = await HostelAddBed(formData);
      if (response?.data?.status) {
        closeModal("addNewBed");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getHostelBedsList();
    }
  };
  const createHostelRoom = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      formData.append("hostel_id", hostel_id);
      const response = await HostelRoomAdd(formData);
      if (response?.data?.status) {
        closeModal("addNewRoom");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getHostelRoomsList();
      getHostelBedsList();
    }
  };

  const updateHostelBed = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await HostelBedUpdate(formData);
      if (response?.data?.status) {
        closeModal("editBed");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getHostelBedsList();
    }
  };

  const updateHostelBedStatus = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await HostelBedStatusChange(formData);
      if (response?.data?.status) {
        closeModal("editBedStatus");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getHostelBedsList();
    }
  };

  const deleteHostel = async (id) => {
    setLoading(true);
    try {
      const response = await HostelBedDelete(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getHostelBedsList();
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid">
                <WelcomeBar />

                {/* =====================================================
                    PAGE HEADER
                ====================================================== */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
                  <div>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <h4 className="mb-0 fw-bold">Rooms & Beds</h4>
                      <span className="badge bg-label-primary rounded-pill">
                        Hostel
                      </span>
                    </div>

                    <p className="text-muted mb-0">
                      Manage rooms, beds and occupancy
                    </p>
                  </div>

                  <div className="d-flex gap-2">
                    {hasAccess("/hostel/room/add") && (
                      <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#addNewRoom"
                      >
                        <i className="ri-add-line"></i>
                        <span>Add Room</span>
                      </button>
                    )}

                    {hasAccess("/hostel/beds/add") && (
                      <button
                        type="button"
                        className="btn btn-label-primary d-flex align-items-center gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#addNewBed"
                      >
                        <i className="ri-hotel-bed-line"></i>
                        <span>Add Bed</span>
                      </button>
                    )}
                  </div>
                </div>

                {/* =====================================================
                    SUMMARY CARDS
                ====================================================== */}
                <div className="row g-3 mb-4">
                  {/* TOTAL */}
                  <div className="col-xl-4 col-md-4">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body d-flex align-items-center justify-content-between">
                        <div>
                          <p className="text-muted mb-1 small fw-medium">
                            Total Beds
                          </p>

                          <h3 className="mb-0 fw-bold">{beds?.total || 0}</h3>
                        </div>

                        <div
                          className="rounded-3 bg-label-primary d-flex align-items-center justify-content-center"
                          style={{
                            width: "46px",
                            height: "46px",
                          }}
                        >
                          <i className="ri-hotel-bed-line fs-4 text-primary"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* OCCUPIED */}
                  <div className="col-xl-4 col-md-4">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body d-flex align-items-center justify-content-between">
                        <div>
                          <p className="text-muted mb-1 small fw-medium">
                            Current View
                          </p>

                          <h6 className="mb-0 fw-semibold">
                            {roomId
                              ? "Filtered by Room"
                              : search
                                ? "Search Results"
                                : "All Rooms"}
                          </h6>
                        </div>

                        <div
                          className="rounded-3 bg-label-info d-flex align-items-center justify-content-center"
                          style={{
                            width: "46px",
                            height: "46px",
                          }}
                        >
                          <i className="ri-filter-3-line fs-4 text-info"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* HOSTEL */}
                  <div className="col-xl-4 col-md-4">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body d-flex align-items-center justify-content-between">
                        <div>
                          <p className="text-muted mb-1 small fw-medium">
                            Management
                          </p>

                          <h6 className="mb-0 fw-semibold">Bed Allocation</h6>
                        </div>

                        <div
                          className="rounded-3 bg-label-success d-flex align-items-center justify-content-center"
                          style={{
                            width: "46px",
                            height: "46px",
                          }}
                        >
                          <i className="ri-building-4-line fs-4 text-success"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* =====================================================
                    FILTER BAR
                ====================================================== */}
                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-body p-3">
                    <div className="row g-2 align-items-center">
                      {/* ROOM */}
                      <div className="col-lg-4 col-md-5">
                        <div className="input-group">
                          <span className="input-group-text bg-transparent">
                            <i className="ri-door-line"></i>
                          </span>

                          <select
                            name="room_id"
                            id="room_id"
                            className="form-select"
                            value={roomId}
                            onChange={(e) => setRoomID(e.target.value)}
                          >
                            <option value="">All Rooms</option>

                            {hostel_id &&
                              rooms?.data
                                ?.filter((r) => r.hostel_id == hostel_id)
                                ?.map((room) => (
                                  <option key={room?.id} value={room?.id}>
                                    Room {room?.room_no}
                                  </option>
                                ))}
                          </select>
                        </div>
                      </div>

                      {/* SEARCH */}
                      <div className="col-lg-5 col-md-5">
                        <div className="input-group">
                          <span className="input-group-text bg-transparent">
                            <i className="ri-search-line"></i>
                          </span>

                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Search bed number or room number..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />

                          {search && (
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setSearch("")}
                            >
                              <i className="ri-close-line"></i>
                            </button>
                          )}
                        </div>
                      </div>

                      {/* RESET */}
                      <div className="col-lg-3 col-md-2">
                        <button
                          type="button"
                          onClick={() => {
                            setSearch("");
                            setRoomID("");
                          }}
                          className="btn btn-label-secondary w-100"
                        >
                          <i className="ri-refresh-line me-1"></i>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* =====================================================
                    BED LIST
                ====================================================== */}
                <div className="card border-0 shadow-sm">
                  {/* HEADER */}
                  <div className="card-header border-bottom py-3 px-4">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                      <div>
                        <h5 className="mb-1 fw-bold">Bed Allocation</h5>

                        <span className="text-muted small">
                          {beds?.total || 0} beds available in the list
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        {roomId && (
                          <span className="badge bg-label-primary rounded-pill px-3 py-2">
                            <i className="ri-door-line me-1"></i>
                            Room Filter Applied
                          </span>
                        )}

                        {search && (
                          <span className="badge bg-label-info rounded-pill px-3 py-2">
                            <i className="ri-search-line me-1"></i>
                            Search Active
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* TABLE */}
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead>
                        <tr className="text-nowrap">
                          <th className="ps-4 text-muted fw-semibold">#</th>
                          <th className="text-muted fw-semibold">Hostel</th>
                          <th className="text-muted fw-semibold">Room</th>
                          <th className="text-muted fw-semibold">Bed</th>
                          <th className="text-muted fw-semibold">Charge</th>
                          <th className="text-muted fw-semibold">Status</th>
                          <th className="text-center pe-4 text-muted fw-semibold">
                            Actions
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {beds?.data?.length > 0 ? (
                          beds.data.map((bed, index) => (
                            <tr key={bed?.id}>
                              {/* INDEX */}
                              <td className="ps-4">
                                <span className="text-muted">
                                  {beds?.from ? beds.from + index : index + 1}
                                </span>
                              </td>

                              {/* HOSTEL */}
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div
                                    className="bg-label-primary rounded-2 d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      minWidth: "36px",
                                    }}
                                  >
                                    <i className="ri-building-4-line text-primary"></i>
                                  </div>

                                  <a
                                    href="HostelManagementview"
                                    className="text-body fw-semibold text-decoration-none"
                                  >
                                    {bed?.hostel?.name || "-"}
                                  </a>
                                </div>
                              </td>

                              {/* ROOM */}
                              <td>
                                <span className="fw-semibold">
                                  Room {bed?.room?.room_no || "-"}
                                </span>
                              </td>

                              {/* BED */}
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <i className="ri-hotel-bed-line text-muted"></i>

                                  <span className="fw-semibold">
                                    {bed?.bed_no || "-"}
                                  </span>
                                </div>
                              </td>

                              {/* CHARGE */}
                              <td>
                                <span className="fw-semibold">
                                  ₹ {bed?.bed_charge ?? "0"}
                                </span>
                              </td>

                              {/* STATUS */}
                              <td>
                                <span
                                  className={`badge rounded-pill px-3 py-2 ${
                                    bed?.status === "Occupied"
                                      ? "bg-label-danger"
                                      : bed?.status === "Vacant"
                                        ? "bg-label-success"
                                        : "bg-label-warning"
                                  }`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#editBedStatus"
                                  onClick={() => setModalData(bed)}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <span
                                    className="d-inline-block rounded-circle me-1"
                                    style={{
                                      width: "6px",
                                      height: "6px",
                                      verticalAlign: "middle",
                                      background: "currentColor",
                                    }}
                                  ></span>

                                  {bed?.status || "Unknown"}
                                </span>
                              </td>

                              {/* ACTIONS */}
                              <td className="pe-4">
                                <div className="d-flex justify-content-center gap-2">
                                  {hasAccess("/hostel/beds/edit") && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label-info"
                                      data-bs-toggle="modal"
                                      data-bs-target="#editBed"
                                      onClick={() => setModalData(bed)}
                                    >
                                      <i className="ri-edit-line me-1"></i>
                                      Edit
                                    </button>
                                  )}

                                  {hasAccess("/hostel/beds/delete") && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label-danger"
                                      onClick={() =>
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "This action will permanently delete !",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#d33",
                                          cancelButtonColor: "#6c757d",
                                          confirmButtonText: "Yes, delete it!",
                                          cancelButtonText: "Cancel",
                                        }).then(async (result) => {
                                          if (result.isConfirmed) {
                                            deleteHostel(bed?.id);
                                          }
                                        })
                                      }
                                    >
                                      <i className="ri-delete-bin-line me-1"></i>
                                      Delete
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7">
                              <div className="text-center py-5">
                                <div
                                  className="bg-label-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                  }}
                                >
                                  <i className="ri-hotel-bed-line fs-2 text-primary"></i>
                                </div>

                                <h6 className="fw-bold mb-1">No beds found</h6>

                                <p className="text-muted mb-0">
                                  No beds match your current filters.
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* =====================================================
                      FOOTER / PAGINATION
                  ====================================================== */}
                  {beds?.data?.length > 0 && (
                    <div className="card-footer bg-transparent border-top px-4 py-3">
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                        <span className="text-muted small">
                          Showing <strong>{beds?.from || 0}</strong> -{" "}
                          <strong>{beds?.to || 0}</strong> of{" "}
                          <strong>{beds?.total || 0}</strong>
                        </span>

                        <nav aria-label="Page navigation">
                          <ul className="pagination pagination-sm mb-0">
                            {beds?.links?.map((btn, i) => (
                              <li
                                key={`${btn?.label}-${i}`}
                                className={`page-item ${
                                  btn?.active ? "active" : ""
                                } ${btn?.url ? "" : "disabled"}`}
                              >
                                <button
                                  type="button"
                                  className="page-link"
                                  onClick={() => {
                                    if (beds?.links?.length === i + 1) {
                                      btn?.url &&
                                        setPage(beds?.current_page + 1);
                                    } else if (i === 0) {
                                      btn?.url &&
                                        setPage(beds?.current_page - 1);
                                    } else {
                                      setPage(btn.label);
                                    }
                                  }}
                                >
                                  {beds?.links?.length === i + 1 ? (
                                    <i className="ri-arrow-right-s-line"></i>
                                  ) : i === 0 ? (
                                    <i className="ri-arrow-left-s-line"></i>
                                  ) : (
                                    btn?.label
                                  )}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>

      {/* =====================================================
          EDIT BED
      ====================================================== */}
      <div className="modal fade" id="editBed" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <form onSubmit={updateHostelBed}>
              <div className="modal-header px-4 py-3">
                <div>
                  <h5 className="modal-title fw-bold mb-1">Edit Bed</h5>
                  <small className="text-muted">Update bed information</small>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body px-4 py-4">
                <input type="hidden" name="id" value={modalData?.id || ""} />

                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Bed No"
                        name="bed_no"
                        defaultValue={modalData?.bed_no}
                        required
                      />
                      <label>Bed No</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Bed Charge"
                        name="bed_charge"
                        defaultValue={modalData?.bed_charge}
                        required
                      />
                      <label>Bed Charge</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer px-4 py-3">
                <button
                  type="button"
                  className="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Updating...
                    </>
                  ) : (
                    <>
                      <i className="ri-save-line me-1"></i>
                      Update Bed
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* =====================================================
          ADD ROOM
      ====================================================== */}
      <div
        className="modal fade"
        id="addNewRoom"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <form onSubmit={createHostelRoom}>
              <div className="modal-header px-4 py-3">
                <div>
                  <h5 className="modal-title fw-bold mb-1">Add Room</h5>
                  <small className="text-muted">Create a new hostel room</small>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body px-4 py-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Room No"
                        name="room_no"
                        required
                      />
                      <label>Room No</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Total Beds"
                        name="total_bed"
                        required
                      />
                      <label>Total Beds</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Bed Charge"
                        name="bed_charge"
                      />
                      <label>Bed Charge</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer px-4 py-3">
                <button
                  type="button"
                  className="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Creating...
                    </>
                  ) : (
                    <>
                      <i className="ri-add-line me-1"></i>
                      Add Room
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* =====================================================
          ADD BED
      ====================================================== */}
      <div
        className="modal fade"
        id="addNewBed"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <form onSubmit={createHostelBed}>
              <div className="modal-header px-4 py-3">
                <div>
                  <h5 className="modal-title fw-bold mb-1">Add Bed</h5>
                  <small className="text-muted">
                    Add a bed to an existing room
                  </small>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body px-4 py-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        name="room_id"
                        className="form-select"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select Room
                        </option>

                        {hostel_id &&
                          rooms?.data
                            ?.filter((r) => r.hostel_id == hostel_id)
                            ?.map((roomItem) => (
                              <option key={roomItem?.id} value={roomItem?.id}>
                                Room {roomItem?.room_no}
                              </option>
                            ))}
                      </select>

                      <label>Select Room</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        className="form-control"
                        placeholder="Bed Charge"
                        name="bed_charge"
                      />
                      <label>Bed Charge</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer px-4 py-3">
                <button
                  type="button"
                  className="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Creating...
                    </>
                  ) : (
                    <>
                      <i className="ri-add-line me-1"></i>
                      Add Bed
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* =====================================================
          EDIT STATUS
      ====================================================== */}
      <div
        className="modal fade"
        id="editBedStatus"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <form onSubmit={updateHostelBedStatus}>
              <div className="modal-header px-4 py-3">
                <div>
                  <h5 className="modal-title fw-bold mb-1">
                    Change Bed Status
                  </h5>

                  <small className="text-muted">
                    Update availability status
                  </small>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body px-4 py-4">
                <input type="hidden" name="id" value={modalData?.id || ""} />

                <div className="d-flex align-items-center justify-content-between p-3 rounded-3 bg-label-secondary mb-3">
                  <div>
                    <small className="text-muted d-block">Bed</small>
                    <strong>{modalData?.bed_no || "-"}</strong>
                  </div>

                  <div className="text-end">
                    <small className="text-muted d-block">Current Status</small>
                    <strong>{modalData?.status || "-"}</strong>
                  </div>
                </div>

                <div className="form-floating form-floating-outline">
                  <select
                    name="status"
                    className="form-select"
                    defaultValue={modalData?.status || ""}
                  >
                    <option value="Occupied">Occupied</option>
                    <option value="Vacant">Vacant</option>
                    <option value="Out of order">Out Of Order</option>
                  </select>

                  <label>Bed Status</label>
                </div>
              </div>

              <div className="modal-footer px-4 py-3">
                <button
                  type="button"
                  className="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Updating...
                    </>
                  ) : (
                    <>
                      <i className="ri-save-line me-1"></i>
                      Update Status
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
